import { Suspense, type FC } from 'react';
import { LoadingComponent } from '../../components/global/LoadingComponent.tsx';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary.tsx';
import { dibsLazyClient } from 'dibs-lazy/exports/dibsLazyClient.ts';

import { type PdpSharedImageGalleryModalProps } from './PdpSharedImageGalleryModal.tsx';

const PdpSharedImageGalleryModal = dibsLazyClient<FC<PdpSharedImageGalleryModalProps>>(
    () =>
        import(
            /* webpackChunkName: "PdpSharedImageGalleryModal" */
            './PdpSharedImageGalleryModal.tsx'
        )
);

export const PdpSharedImageGalleryModalLazy: FC<PdpSharedImageGalleryModalProps> = props => {
    if (!props.isOpen) {
        return null;
    }
    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense fallback={<LoadingComponent black />}>
                <PdpSharedImageGalleryModal {...props} />
            </Suspense>
        </ErrorBoundary>
    );
};
